module.exports = __webpack_public_path__ + "static/img/serviceMask.b9d39bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/serviceMask.png
// module id = petu
// module chunks = 44